// The one place the storefront states who we are. Footers, the contact page and the
// quotation form all read from here, so a phone number changes in a single edit.
export const company = {
  name: 'Sweet Home Gallery',
  // Absolute, no trailing slash. Canonical URLs, og:url and the sitemap are all
  // built from this, so it must be the origin the public actually visits — a wrong
  // value here silently points every canonical tag at a site that isn't ours.
  url: (process.env.VUE_APP_SITE_URL || 'https://sweethome-lb.com').replace(/\/$/, ''),
  tagline: 'Custom furniture & interior, made in Lebanon.',
  shortTagline: 'Furniture & Interiors',
  description:
    'Sweet Home Gallery designs and builds furniture in our Ghazir workshop — sofas, dining, bedroom and fit-outs for homes and restaurants across Lebanon.',
  address: 'Ghazir, Lebanon',
  phone: '03 167 477',
  phoneHref: 'tel:+96103167477',
  whatsapp: '96103167477',
  // TODO: replace with a business address before launch — this is a personal inbox.
  email: 'charbelghanem819@gmail.com',
  hours: 'Monday to Saturday, 9:00 – 18:00',
  social: {
    instagram: 'https://www.instagram.com/sweethomegallery.lb/',
    tiktok: 'https://www.tiktok.com/@sweethomegallery.lb',
  },
};

export const whatsappLink = (message = '') =>
  `https://wa.me/${company.whatsapp}${message ? `?text=${encodeURIComponent(message)}` : ''}`;

/**
 * The three channels we actually run, in the order they should appear everywhere.
 *
 * One list rather than per-footer markup: the template shipped four hardcoded
 * icons pointing at "#" in one footer and a different pair in another, so the
 * homepage and the about page disagreed about which networks exist. An icon that
 * goes nowhere reads as a broken site, so anything without a URL drops out here
 * instead of rendering dead.
 */
export const socialProfiles = [
  { label: 'Instagram', href: company.social.instagram, icon: 'fa-brands fa-instagram' },
  { label: 'TikTok', href: company.social.tiktok, icon: 'fa-brands fa-tiktok' },
  { label: 'WhatsApp', href: whatsappLink(), icon: 'fa-brands fa-whatsapp' },
].filter((link) => link.href);
